import { SchedulingFlowRouteName } from '../../../../router/routes/schedulingFlow/model.js';

var SchedulingFlowParam;
(function (SchedulingFlowParam) {
    SchedulingFlowParam["DRAFT_WAYPOINT_ID"] = "draftWaypointID";
    SchedulingFlowParam["VISIT_TYPE"] = "visitType";
})(SchedulingFlowParam || (SchedulingFlowParam = {}));
const SchedulingFlowRouteTitles = {
    [SchedulingFlowRouteName.SCHEDULING_FLOW]: '',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_RESCHEDULE_LOADING]: '',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_ADDRESS]: 'Address',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_DATE_RANGE]: 'Date & time',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_FLEXIBLE_OPTION]: 'Flexibility',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_TIME]: 'Date & time',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_TIME_RANGE]: 'Time Range',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_WALK_IN_DATE]: 'Walk In Date',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_VISIT_OVERVIEW]: 'Overview',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_REVIEW]: 'Review',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_COMPLETE_PROFILE]: 'Profile',
    [SchedulingFlowRouteName.SCHEDULING_FLOW_PRACTICE_INFO]: 'Practice',
};

export { SchedulingFlowParam, SchedulingFlowRouteTitles };
